var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-delivery-and-payment"},[_c('tabs-page',{attrs:{"title":"Доставка и оплата","tabs":_vm.activeTabs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }